<!-- src/App.vue -->
<!-- Author Igor Veynik | Site: NexusLab.ru | Telegram: @thenexus | created 30.10.2026 | updated 30.10.2026 -->
<template>
  <!-- Страница входа — без каркаса -->
  <router-view v-if="isBare" />

  <div v-else class="layout" :class="{ 'is-collapsed': collapsed, 'is-nav-open': navOpen }">
    <Sidebar :collapsed="collapsed" @toggle="toggleCollapsed" @navigate="navOpen = false" />
    <div class="layout-backdrop" @click="navOpen = false"></div>

    <div class="layout-main">
      <Header @open-nav="navOpen = true" />
      <main class="workarea">
        <router-view v-slot="{ Component, route }">
          <transition name="page-fade" mode="out-in">
            <component :is="Component" :key="route.matched[0]?.path" />
          </transition>
        </router-view>
      </main>
    </div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Sidebar from './components/Sidebar.vue'

const collapsedKey = 'nxSidebarCollapsed'

export default {
  name: 'App',
  components: { Header, Sidebar },
  data() {
    return {
      collapsed: localStorage.getItem(collapsedKey) === '1',
      navOpen: false
    }
  },
  computed: {
    isBare() {
      return this.$route.name === 'login' || !this.$store.getters.isAuthenticated
    }
  },
  watch: {
    $route() {
      this.navOpen = false
    }
  },
  methods: {
    toggleCollapsed() {
      this.collapsed = !this.collapsed
      localStorage.setItem(collapsedKey, this.collapsed ? '1' : '0')
    }
  }
}
</script>

<style lang="scss">
#app { min-height: 100vh; }

.layout {
  display: grid;
  grid-template-columns: var(--sidebar-w) minmax(0, 1fr);
  min-height: 100vh;
  transition: grid-template-columns .2s var(--ease);
}
.layout.is-collapsed { grid-template-columns: var(--sidebar-w-collapsed) minmax(0, 1fr); }
.layout-main { display: flex; flex-direction: column; min-width: 0; }
.layout-backdrop { display: none; }

.workarea {
  flex: 1;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 24px 28px 40px;
  min-width: 0;
}

@media (min-width: 961px) {
  .layout.is-collapsed .brand-text,
  .layout.is-collapsed .nav-text { opacity: 0; pointer-events: none; }
  .layout.is-collapsed .collapse-icon { transform: rotate(180deg); }
}

@media (max-width: 960px) {
  .layout.is-nav-open .sidebar { transform: none; }
  .layout, .layout.is-collapsed { grid-template-columns: minmax(0, 1fr); }
  .layout-backdrop {
    position: fixed; inset: 0; z-index: 90;
    background: rgba(15, 23, 42, .45);
    opacity: 0; pointer-events: none; transition: opacity .2s var(--ease);
  }
  .layout.is-nav-open .layout-backdrop { display: block; opacity: 1; pointer-events: auto; }
  .workarea { padding: 16px 14px 32px; }
}
</style>
